import { useEffect, useCallback, useState } from 'react';
import { getGpsStampHistory } from 'api/stampHistory';
import GpsStampHistoryDomain from 'domain/master/atendenceManagement/gpsStampHistory';

const useGpsStampHistory = (orgCode: string, staffCode: string, targetDateFrom: string, targetDateTo: string, categoryAr: any) => {
  console.log('categoryAr', categoryAr);
  const [gpsStampHistory, setGpsstampHistory] = useState<Array<GpsStampHistoryDomain>>([]);

  const [blocking, setBlocking] = useState(false);

  // データの取得
  const fetchData = useCallback(async () => {
    setBlocking(true);
    const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
    const response = await getGpsStampHistory(companyCode, orgCode, staffCode, targetDateFrom, targetDateTo, categoryAr);
    console.log(`response = ${String(response)}`);
    setGpsstampHistory(response.map((result: any) => new GpsStampHistoryDomain(result)));
    setBlocking(false);
  }, [categoryAr, orgCode, staffCode, targetDateFrom, targetDateTo]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { gpsStampHistory, setGpsstampHistory, blocking };
};

export default useGpsStampHistory;
